import { __awaiter } from "tslib";
import { WritableStream } from '@yume-chan/adb';
function toHex(value) {
    return value.toString(16).padStart(2, '0').toUpperCase();
}
export class WebCodecsDecoder {
    constructor() {
        // Usually, browsers can decode most configurations,
        // So let device choose best profile and level for itself.
        this.maxProfile = undefined;
        this.maxLevel = undefined;
        this._frameRendered = 0;
        this.animationFrame = 0;
        this.render = () => {
            if (this.lastFrame) {
                this._frameRendered += 1;
                this.context.drawImage(this.lastFrame, 0, 0);
                this.lastFrame.close();
                this.lastFrame = undefined;
            }
            this.animationFrame = requestAnimationFrame(this.render);
        };
        this._renderer = document.createElement('canvas');
        this.context = this._renderer.getContext('2d');
        this.decoder = new VideoDecoder({
            output: (frame) => {
                if (this.lastFrame) {
                    this.lastFrame.close();
                }
                this.lastFrame = frame;
                if (!this.animationFrame) {
                    // Start render loop on first frame
                    this.render();
                }
            },
            error() { },
        });
        this._writable = new WritableStream({
            write: (packet) => __awaiter(this, void 0, void 0, function* () {
                switch (packet.type) {
                    case 'configuration':
                        this.configure(packet.data);
                        break;
                    case 'frame':
                        this.decoder.decode(new EncodedVideoChunk({
                            // Treat `undefined` as `key`, otherwise won't decode.
                            type: packet.keyframe === false ? 'delta' : 'key',
                            timestamp: 0,
                            data: packet.data,
                        }));
                        break;
                }
            })
        });
    }
    get writable() { return this._writable; }
    get renderer() { return this._renderer; }
    get frameRendered() { return this._frameRendered; }
    configure(config) {
        const { profileIndex, constraintSet, levelIndex } = config;
        this._renderer.width = config.croppedWidth;
        this._renderer.height = config.croppedHeight;
        // https://www.rfc-editor.org/rfc/rfc6381#section-3.3
        // ISO Base Media File Format Name Space
        const codec = `avc1.${[profileIndex, constraintSet, levelIndex].map(toHex).join('')}`;
        this.decoder.configure({
            codec: codec,
            optimizeForLatency: true,
        });
    }
    dispose() {
        cancelAnimationFrame(this.animationFrame);
        this.decoder.close();
    }
}
//# sourceMappingURL=index.js.map